import TNumberstepper from './number-stepper'

TNumberstepper.install = Vue => {
  Vue.component(TNumberstepper.name, TNumberstepper)
}

export {
  TNumberstepper
}



// WEBPACK FOOTER //
// ./src/module/number-stepper/index.js